import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// eslint-disable-next-line
import { Search } from "@mui/icons-material";
// eslint-disable-next-line
import { Avatar, Button, Stack,InputAdornment,TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { useHistory, Link } from "react-router-dom";
import React from "react";
import "./Header.css";
import "./Products.css"
// eslint-disable-next-line
import { useState } from "react";

const Header = ({ children, hasHiddenAuthButtons }) => {
  const history = useHistory();
  const logoutButton = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("balance");
    history.push("/");
    window.location.reload();
  };
  const loginButton = () => {
    history.push("/login");
  };
  const registerButton = () => {
    history.push("/register");
  };
  if (hasHiddenAuthButtons) {
    return (
      <Box className="header">
        <Box className="header-title">
          <Link to="/">
            <img src="logo_light.svg" alt="Qkart-icon" />
          </Link>
        </Box>
        {children}
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={() => history.push("/")}
        >
          Back to explore
        </Button>
      </Box>
    );
  }
  return (
    <Box className="header">
      <Box className="header-title">
        <Link to="/">
          <img src="logo_light.svg" alt="QKart-icon"></img>
        </Link>
      </Box>
      {children}
      {localStorage.getItem("username") ? (
        <Stack direction="row" spacing={1} alignItems="center">
          <Avatar
            src="avatar.png"
            alt={`${localStorage.getItem("username")}`}
          />
          <p className="username-text">{localStorage.getItem("username")}</p>
          <Button type="primary" onClick={() => logoutButton()}>
            Logout
          </Button>
        </Stack>
      ) : (
        <Stack direction="row" spacing={1} alignItems="center">
          <Button onClick={() => loginButton()}>Login</Button>
          <Button variant="contained" onClick={() => registerButton()}>
            Register
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default Header;
